export default __webpack_public_path__ + "static/media/a038-1.2f9a8f21.svg";